/**
 * @flow
 */
import styled from 'react-emotion'
import ResponsiveContainer from '../../core/ResponsiveContainer'
import { Typo14Tangerine3RM, Typo14White2RR } from '../../../themes/Fonts'
import colors from '../../../themes/Colors'
import { tablet, mobile, desktop } from '../../../utils/mixins'
import BookAnotherArrow from '../../Icons/BookAnotherArrow'

export const SuccessFormMobileContainer = styled(ResponsiveContainer)`
  margin-top: 15%;
  display: none;
`

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: row;
  position: fixed;
  top: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;
  z-index: 100;
  background: ${colors.darkTwoDefault};
  overflow: auto;
`
export const SuccessFormDesktopContainer = styled(ResponsiveContainer)`
  @media (min-width: 320px) and (max-width: 1200px) {
    padding-left: 0.5em;
    padding-right: 0.5em;
  }
  @media (min-width: 768px) and (max-width: 1200px) {
    max-width: 35.8125em;
  }
`

export const SuccessfulFormSection = styled('div')`
  background-color: ${colors.blackTwo};
  padding-top: 1.875em;
  padding-bottom: 1.875em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
`
export const SuccessfulFormDesktopSection = styled('div')`
  background-color: ${colors.blackDefault};
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  position: relative;
  margin-top: 18%;
  @media (min-width: 320px) and (max-width: 1200px) {
    flex-direction: column;
    margin-bottom: 5.214em;
  }
`

export const HorizontalLine = styled('div')`
  width: 20em;
  height: 1px;
  opacity: 0.1;
  background-color: ${colors.gainsBoro};
`

export const BookAnotherButtonContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding-top: 1.5em;
  padding-bottom: 1.5em;
`
export const BookAnotherDesktopButtonContainer = styled('div')`
  user-select: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding-bottom: 3.875em;
  @media (min-width: 320px) and (max-width: 767px) {
    padding-bottom: 0;
  }
`
const Typo14Tangerine3RMWithArticleTag = Typo14Tangerine3RM.withComponent(
  'article'
)
export const BookAnotherText = styled(Typo14Tangerine3RMWithArticleTag)`
  padding-right: 0.714em;
  font-family: din-2014;
`
export const ModalButtonText = styled('article')`
  font-family: din-2014;
  font-size: 0.875em;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${colors.whiteTwo};
`
export const ModalButtonContainer = styled('div')`
  width: 12.875em;
  height: 2.5em;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  background-color: ${colors.tangerineThree};
  cursor: pointer;
  margin-top: 1.25em;
  margin-bottom: 1.25em;
`
export const VerticalLine = styled('div')`
  width: 0.2em;
  height: 17em;
  opacity: 0.15;
  background-color: ${colors.whiteTwo};
  margin-top: 1.875em;
  margin-right: 2.875em;
  @media (min-width: 320px) and (max-width: 767px) {
    width: 90%;
    height: 1px;
    opacity: 0.1;
    background-color: ${colors.gainsBoro};
    margin-bottom: 1.875em;
    margin-left: auto;
    margin-right: auto;
  }
  @media (min-width: 768px) and (max-width: 1200px) {
    width: 31.5em;
    height: 1px;
    opacity: 0.15;
    background-color: ${colors.whiteTwo};
    margin: auto;
    margin-top: 1.25em;
    margin-bottom: 2.5em;
  }
`
export const CloseModalIconContainer = styled('div')`
  position: absolute;
  top: -5%;
  right: -1%;
  cursor: pointer;
  z-index: 10;
  @media (min-width: 320px) and (max-width: 1200px) {
    top: -2%;
    right: -2%;
  }
`
const Typo14White2RRWIthArticleTag = Typo14White2RR.withComponent('article')
export const ContinueButtonText = styled(Typo14White2RRWIthArticleTag)`
  font-family: din-2014;
`
export const ContinueButtonContainer = styled('div')`
  width: 12.875em;
  height: 2.5em;
  border-radius: 2px;
  background-color: rgb(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-top: 1.5em;
  cursor: pointer;
`

export const MapBackground = styled('iframe')`
  width: auto;
  height: auto;
  margin: 12px;
  ${mobile} {
    width: auto;
    height: 320px;
    margin: 0px;
  }
  ${tablet} {
    width: auto;
    height: 213px;
    margin: 0px;
  }
  ${desktop} {
    min-width: 425px;
  }
  @media screen and (width: 1024px) and (orientation: landscape) {
    min-height: 400px;
  }
`
export const BookAnotherArrowIcon = styled(BookAnotherArrow)`
  display: flex;
`



// WEBPACK FOOTER //
// ./src/components/IbcArcade/BookingResponseMessage/styledComponents.js